import {
  FETCH_START,
  FETCH_END,
  CALCULATION_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
export const runCommissionCalculation = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    runCommissionCalculationApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response)
        //dispatch(runCommissionCalculationSuccess(response.data.response));
        // history.push('/sales-commission/calculation-report');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const runCommissionCalculationApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('sc/process-data', data, { headers: headers });
  return result;
};

export const runCommissionCalculationSuccess = (data) => {
  return {
    type: CALCULATION_SUCCESS,
    data,
  };
};
